import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalService } from 'src/app/core/services/global.service';
import * as printJS from 'print-js';
declare var $: any;

@Component({
    standalone: false,
    selector: 'app-print-view',
    templateUrl: './print-view.component.html',
    styleUrls: ['./print-view.component.css']
})
export class PrintViewComponent implements OnInit {
    @Input() modalDetails: any;
    @Input() width;
    @Input() height;

    constructor(
        private global: GlobalService,
        private sanitizer: DomSanitizer
    ) { }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        $("#staticBackdrop").modal("show");
    }

    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    closeModal() {
        $("#staticBackdrop").modal("hide");
        this.global.closeBrochureModal.emit(false);
    }

    printView() {
        printJS({
            printable: 'print-page',
            type: 'html',
            targetStyles: ['*']
        })
    }

}
